import gql from 'graphql-tag';
import { useQuery as defaultUseQuery } from '@apollo/react-hooks';

import { ApolloInjection, CurrentUserQuery } from '@zapier/upsells/src/types';

export const currentUserQuery = gql`
  query upsells_currentUserQuery {
    currentUser: currentUserV2 {
      currentAccountId
      email
      id
      isMasquerade
    }
  }
`;

type Props = {
  skip?: boolean;
} & ApolloInjection;

export const useCurrentUser = (props: Props = {}) => {
  const useQuery = props?.useQuery || defaultUseQuery;

  const { data, error, loading: isLoading } = useQuery<CurrentUserQuery>(
    currentUserQuery,
    {
      skip: props?.skip,
    }
  );

  return {
    currentUser: data?.currentUser,
    error: error?.message,
    isLoading,
  };
};
